module.exports = __webpack_public_path__ + "static/media/B_E02.58b4e6e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_E02.png
// module id = 61
// module chunks = 0